<template>
  <form class="autocomplete" autocomplete="off">
    <div class="input-group">

      <input class="form-control" v-on:click="searchClick" v-on:keydown="keydown" v-model="inputValue" type="text" v-bind:name="inputValue" v-bind:placeholder="placeholder">

      <div class="input-group-append">

        <button class="btn btn-search" type="button">
          <span><translate item="Search" /></span>
          <i class="icon-search"></i>
        </button>

        <button v-on:click="cancel" class="btn btn-cancel" type="button">
          <span><translate item="Cancel" /></span>
          <i class="icon-close"></i>
        </button>

      </div>

      <div class="autocomplete-items">
        <div v-for="item in items" v-on:click="itemSelected( item)" v-on:mouseover="mouseTakesOver($event,item)" class="item"><span v-html=getName(item)></span></div>
      </div>

    </div>

  </form>
</template>

<script>
  import { services } from '../Services/Services';
  import translate from './translate';

  export default {
    name: 'autocomplete',

    model: {
      prop: 'value',
      event: 'change'
    },

    props: {
      "name": String,
      "placeholder": String,
      "mincharacters": { type: Number, default: 2 },
      "maxresults": { type: Number, default: 10 },
      "value": String,
      "displayproperty": { type: String, default: 'productName'}
    },

    data: function () {
      return {
        items: [],       
        currentFocus: -1,
        activeEl: null,
        timer: null,
        inputValue : ''
      }
    },
    
    watch: {
      value: function (value) {
        this.inputValue = value;
      },
      inputValue: function (value) {
        this.doDirectSearch();
        this.$emit('change', value);
      }
    },

    methods: {
      searchClick: function () {
        this.doDirectSearch();
      },
      cancel: function () {
        this.items = [];
        this.inputValue = '';
        this.$emit('item-selected', null);
      },
      getName: function (product) {

        var name = product.content[this.displayproperty];

        if (!name || !name.length) {
          name = product.content['productName'];
        }

        name = name.toUpperCase();

        var index = name.indexOf(this.value.toUpperCase());
        var returnName = '';

        if (index >= 0 && name.substr(index, this.value.length).toUpperCase() === this.value.toUpperCase()) {
          returnName = name.substr(0, index);
          returnName += "<strong>" + name.substr(index, this.value.length) + "</strong>";
          returnName += name.substr(this.value.length + index);
        } else {
          returnName = name;
        }
        return returnName;
      },
      mouseTakesOver: function (event, item) {

        // reset keyboard control on mouse hover on autocomplete item
        if (this.activeEl) {
          this.removeActive(this.activeEl);
        }

        this.currentFocus = Array.prototype.slice.call(event.target.parentNode.children).indexOf(event.target);
        this.setActive(event.target, false);
      },

      itemSelected: function (item) {
        //this.items = [];
        this.$emit('item-selected', item);
      },

      keydown: function (e) {

        var resultDiv = document.getElementsByClassName("autocomplete-items")[0];
        var x = resultDiv.getElementsByTagName("div");

        if (x) {
          if (e.keyCode == 40) {
            // If the arrow DOWN key is pressed,
            this.removeActive(x[this.currentFocus]);
            this.currentFocus++;
            if (this.currentFocus >= x.length) this.currentFocus = 0;
            this.setActive(x[this.currentFocus], true);
            e.preventDefault();
          } else if (e.keyCode == 38) { //up
            // If the arrow UP key is pressed,
            this.removeActive(x[this.currentFocus]);
            this.currentFocus--;
            if (this.currentFocus < 0) this.currentFocus = (x.length - 1);
            this.setActive(x[this.currentFocus], true);
            e.preventDefault();
          } else if (e.keyCode == 13) {
            /*If the ENTER key is pressed, prevent the form from being submitted, open result */
            e.preventDefault();

            if (this.items.length == 1) {
              this.itemSelected(this.items[0]);
            }else  if (this.currentFocus > -1) {
              this.itemSelected(this.items[this.currentFocus]);
            }

          }
        }
      },

      setActive: function (el, doScroll) {
        if (el) {
          el.classList.add("autocomplete-active")
          this.activeEl = el;
          // IE not supported? todo
          if (doScroll) {
            el.parentNode.scrollTo({
              top: el.offsetTop,
              left: 0,
              behavior: 'smooth'
            });
          }

        };
      }
      , removeActive: function (el) {
        if (el) { el.classList.remove("autocomplete-active"); }
      },


      // get direct search results
      doDirectSearch: function () {
        var val = this.inputValue;
        var vm = this;
       
        if (!val) { return false; }

        if (val.length < this.mincharacters) {
          return false;
        }

        var getResults = function () {
          var headers = {};
          var enableCache = true;

          if (enableCache) {
            headers.PwaEnableCache = 1;
          } else {
            headers.PwaDisableCache = 1;
          }

          $.ajax('/umbraco/vwa/JsonListSurface/Search/', { headers: headers, data: { "query": val, "maxresults": vm.maxresults }, complete: _complete, error: function (err) { console.log(err); } });

          function _complete(data) {
            vm.items = [];
            if (!data.responseJSON) {
              // empty
              return;
            }

            vm.currentFocus = -1;
            vm.items = data.responseJSON.products;
          }
        };

        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = window.setTimeout(getResults, 100);
      }


    },
    components: { translate },

    mounted: function () {
      var vm = this;

      /*execute a function when someone clicks in the document:*/
      document.addEventListener("click", function (e) {
        vm.items = [];
      });

    }

  }


</script>



// WEBPACK FOOTER //
// Vue/Src/Components/autocomplete.vue